import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  public info(message: string, error: any) {
    console.info(new Date() + ' - ' + message + ': ' + JSON.stringify(error));
  }

  public error(message: string, error: any) {
    console.error(new Date() + ' - ' + message + ': ' + JSON.stringify(error));
  }

}
